import React from 'react'
import {DataBuyer as BuyerUser} from '../Modules/BuyerUser/DataBuyer'

interface Props {
  dataBuyer: BuyerUser
  onClickBuyerAgency?: (authToken) => void
  onClickAddCard?: (typeGateway)=> void
}

const AgencyHeaderView = ({dataBuyer, onClickBuyerAgency, onClickAddCard}: Props) => {
  
  if (!dataBuyer) {
    console.log('!dataBuyer')
    return null
  }
  
  const handleClickBuyerAgency = (authToken) => {
    if (onClickBuyerAgency) {
      onClickBuyerAgency(authToken)
    }
    
  }
  
  const handleClickDataBooking = () => {
    
  }
  
  return (
    <>
      <div style={{backgroundColor: 'red'}}>
        {/*{onClickBuyerAgency && <> <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <button onClick={(e) => {
            handleClickBuyerAgency('b72100166c738aca8fd960bd06c64c6d26825dbdfc302a9861eed311295ac35f')
          }}>
            de ViajesHakuna info
          </button>
          <button onClick={() => handleClickBuyerAgency('888282b4f4c92f7d776afbfb1d8a81f1391260d392e1146161f30618f01bac05')}>
            Agencia aquasur - buyer01
          </button>
          <button onClick={() => handleClickBuyerAgency('5geet4381becfa2c71c5fd2dfa51ebb4f28959e01cb46e8345019b4d6004ce10')}>
            Agencia del sur - buyer03
          </button>
        </div></>}*/}
        
        {dataBuyer && dataBuyer.client?.agency && <>
          <div
            className="flex items-stretch bg-red-500"
          >
            <div className="flex-1 p-6">
              <h1 style={{color: 'white'}}>{`${dataBuyer.client.agency.name} - ${dataBuyer.client.agency.code}`}</h1>
              <hr/>
              <div style={{textAlign: 'center'}}>
                <h2 style={{color: 'white'}}>{`${dataBuyer.user.name} - ${dataBuyer.user.surname}`}</h2>
                <h2 style={{color: 'white'}}>{`${dataBuyer.user.email}`}</h2>
              </div>
            </div>
            <div className="w-64 flex items-center justify-center">
              {onClickAddCard && 
                <div>
                  <button
                    className="px-5 py-2 bg-blue-t0 text-white rounded hover:bg-blue-700 mb-2"
                    onClick={() => {
                      if (onClickAddCard) {
                        onClickAddCard('CREDITCARD')
                      }
                    }}
                    >
                      {'añadir tarjeta'}
                  </button>
                  <button
                    className="px-5 py-2 bg-blue-t0 text-white rounded hover:bg-blue-700 mt-2"
                    onClick={() => {
                      if (onClickAddCard) {
                        onClickAddCard('DIRDEB')
                      }
                    }}
                  >{'añadir cuenta bancaria'}</button>
                </div>
              }
            </div>
          </div>
          
        </>}
      </div>
    </>
  )
} 

export default AgencyHeaderView